document.addEventListener("DOMContentLoaded", function () {
    const swipers = document.querySelectorAll(".wear-with-it-product-swiper");
  
    swipers.forEach(function (swiperEl) {
      const desk_item = parseFloat(swiperEl.getAttribute("data-desktop_items")) || 3;
      const mac_item = parseFloat(swiperEl.getAttribute("data-mac_items")) || 3;
      const mob_item = parseFloat(swiperEl.getAttribute("data-mobile_items")) || 1.5;
      const ipad_item_vertical = parseFloat(swiperEl.getAttribute("data-ipad_vertical_items")) || 2.5;
      const ipad_item_horizontal = parseFloat(swiperEl.getAttribute("data-ipad_horizontal_items")) || 2.5;
      const slider_mobile_padding = parseFloat(swiperEl.getAttribute("data-mobile-padding"));
      const slider_ipad_vertical_padding = parseFloat(swiperEl.getAttribute("data-ipad-vertical-padding"));
      const slider_ipad_horizontal_padding = parseFloat(swiperEl.getAttribute("data-ipad-horizontal-padding"));
      const slider_desktop_padding = parseFloat(swiperEl.getAttribute("data-desktop-padding"));
      const slider_mac_padding = parseFloat(swiperEl.getAttribute("data-mac-padding"));
      const mobile_offset = parseFloat(swiperEl.getAttribute("data-mobile-offset")) || 0;
      const ipad_vertical_offset = parseFloat(swiperEl.getAttribute("data-ipad-vertical-offset")) || 0;
      const ipad_horizontal_offset = parseFloat(swiperEl.getAttribute("data-ipad-horizontal-offset")) || 0;
      const desktop_offset = parseFloat(swiperEl.getAttribute("data-desktop-offset")) || 0;
      const mac_offset = parseFloat(swiperEl.getAttribute("data-mac-offset")) || 0;
      
  
      const swiper = new Swiper(swiperEl, {
        slidesPerView: getSlidesPerView(swiperEl),
        spaceBetween: getSpaceBetween(swiperEl),
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next.wear-with-it-arrow",
          prevEl: ".swiper-button-prev.wear-with-it-arrow",
        },
        breakpoints: {
          0: {
            slidesPerView: mob_item,
            spaceBetween: slider_mobile_padding,
            slidesOffsetBefore: mobile_offset,
          },
          481: {
            slidesPerView: ipad_item_vertical,
            spaceBetween: slider_ipad_vertical_padding,
            slidesOffsetBefore: ipad_vertical_offset,
          },
          786: {
            slidesPerView: ipad_item_horizontal,
            spaceBetween: slider_ipad_horizontal_padding,
            slidesOffsetBefore: ipad_horizontal_offset,
          },
          1100: {
            slidesPerView: mac_item,
            spaceBetween: slider_mac_padding,
            slidesOffsetBefore: mac_offset,
          },
          1400: {
            slidesPerView: desk_item,
            spaceBetween: slider_desktop_padding,
            slidesOffsetBefore: desktop_offset,
          },
        },
      });
  
      // Helper functions
      function getSlidesPerView(el) {
        const width = window.innerWidth;
        if (width < 749) return parseInt(el.getAttribute("data-mobile_items")) || 1;
        if (width < 990) return parseInt(el.getAttribute("data-ipad_vertical_items")) || 2;
        return parseInt(el.getAttribute("data-desktop_items")) || 3;
      }
  
      function getSpaceBetween(el) {
        const width = window.innerWidth;
        if (width < 749) return parseInt(el.getAttribute("data-mobile-padding")) || 10;
        if (width < 990) return parseInt(el.getAttribute("data-ipad-vertical-padding")) || 15;
        return parseInt(el.getAttribute("data-desktop-padding")) || 20;
      }
    });
  });
  